module.exports = __webpack_public_path__ + "assets/img/logo-sm-grey.737dded6.png";